/**
 * Clasifica el concepto de un egreso en una categoría del reporte
 * (tipo_requisiciones) mediante reglas de lenguaje natural / keywords.
 */

export const CATEGORIAS_IA_EGRESOS = [
  'Nómina Operaciones',
  'Renta sucursal',
  'Servicios Basicos',
  'Marketing',
  'Mantenimiento',
  'Impuestos',
  'Servicios especiales',
  'Otros gastos',
  'Repartición de utilidades',
  'Nómina Teachers',
  'Bonos y Bonificaciones',
  'Comisiones',
  'Insumos',
  'Suscripciones de Sistemas',
  'Transporte',
]

const COLOR_POR_CATEGORIA = {
  'Nómina Operaciones': '#1565C0',
  'Renta sucursal': '#6A1B9A',
  'Servicios Basicos': '#00838F',
  'Marketing': '#E65100',
  'Mantenimiento': '#546E7A',
  'Impuestos': '#C62828',
  'Servicios especiales': '#4527A0',
  'Otros gastos': '#757575',
  'Repartición de utilidades': '#2E7D32',
  'Nómina Teachers': '#0277BD',
  'Bonos y Bonificaciones': '#F9A825',
  'Comisiones': '#AD1457',
  'Insumos': '#558B2F',
  'Suscripciones de Sistemas': '#283593',
  'Transporte': '#00695C',
}

/** Orden: de más específica a más genérica. */
const REGLAS = [
  {
    categoria: 'Repartición de utilidades',
    patrones: [/\bptu\b/i, /repartici[oó]n\s+de\s+utilidad/i, /utilidades\s+pt/i],
  },
  {
    categoria: 'Impuestos',
    patrones: [/\bimss\b/i, /\bisn\b/i, /\bsat\b/i, /\bisr\b/i, /\biva\b/i, /impuesto/i, /infonavit/i, /declaraci[oó]n\s+fiscal/i],
  },
  {
    categoria: 'Suscripciones de Sistemas',
    patrones: [
      /twilio/i, /office\s*365/i, /\bzoom\b/i, /\bcanva\b/i, /\baws\b/i,
      /digital\s*ocean/i, /hosting/i, /dominio/i, /dropbox/i, /\bslack\b/i,
      /notion/i, /github/i, /openai/i, /chatgpt/i, /suscripci[oó]n/i,
      /pago\s+google\s+aplicaci[oó]n/i, /google\s+workspace/i, /licencia\s+(de\s+)?software/i,
      /\bionos\b/i, /\bgodaddy\b/i, /\bnamecheap\b/i, /cloudflare/i, /\bheroku\b/i,
      /google\s+cloud/i, /microsoft\s+365/i, /\badobe\b/i, /\bshopify\b/i,
    ],
  },
  {
    categoria: 'Marketing',
    patrones: [
      /facebook/i, /meta\s*ads/i, /instagram/i, /volanteo/i, /marketing/i,
      /publicidad/i, /google\s*ads/i, /\bflyer/i, /anuncio/i, /campa[nñ]a/i,
      /impresi[oó]n\s+de\s+\d*\s*certificado/i, /certificados?\s+(para|inbi|fast)/i,
      /pago\s+de\s+certificados?/i, /\bcertificados?\b/i, /sellos?\s+dorados/i,
      /\blona(s)?\b/i, /impresi[oó]n\s+en\s+vinil/i, /vinil\s+(adhesivo|impres)/i,
    ],
  },
  {
    categoria: 'Transporte',
    patrones: [
      /gasolina/i, /\buber\b/i, /\bdidi\b/i, /transporte/i, /pasaje/i, /caseta/i,
      /peaje/i, /combustible/i, /estacionamiento/i, /taxi/i, /di[eé]sel/i,
      /movilidad/i, /vi[aá]ticos?/i, /flete/i, /paqueter[ií]a/i, /envio\s+de\s+material/i,
      /env[ií]o\s+de\s+material/i, /traslado/i, /camioneta/i, /renta\s+de\s+(auto|carro|veh[ií]culo)/i,
    ],
  },
  {
    categoria: 'Renta sucursal',
    patrones: [
      /\brenta\b(?!\s+de\s+(auto|carro|veh[ií]culo))/i, /arrendamiento/i,
      /dep[oó]sito\s+del?\s+.*local/i,
      /primer\s+mes\s+del?\s+.*local/i, /pago\s+de\s+el\s+primer\s+mes/i,
      /mes\s+del?\s+.*local/i,
    ],
  },
  {
    categoria: 'Comisiones',
    patrones: [/comisi[oó]n(es)?/i],
  },
  {
    categoria: 'Bonos y Bonificaciones',
    patrones: [/\bbono(s)?\b/i, /bonificaci[oó]n/i, /finiquito/i, /aguinaldo/i, /prima\s*vacacional/i],
  },
  {
    categoria: 'Nómina Teachers',
    patrones: [
      /teacher/i, /quincena\s+\d*\s*teachers?/i, /n[oó]mina\s+teachers?/i,
      /\(?\s*sabatina\s+\d+\s*\)?/i, /pago\s+de\s+quincena.*teacher/i,
      /\(\s*quincena\s+\d+\s*\)/i,
      /\(\s*s[aá]bado\s+sem\.?\s*\d+\s*\)/i,
      /\(\s*sabado\s+sem\.?\s*\d+\s*\)/i,
    ],
  },
  {
    categoria: 'Nómina Operaciones',
    patrones: [
      /n[oó]mina\s+administrativa/i, /n[oó]mina\s+operaciones/i,
      /pago\s+n[oó]mina(?!\s+teacher)/i, /pago\s+nomina(?!\s+teacher)/i,
      /d[ií]a\s+laborado/i, /nomina\s+semana/i, /n[oó]mina\s+semana/i,
      /\(\s*semana\s+\d+\s*\)/i, /\(\s*Q[12]\s*\)/i,
    ],
  },
  {
    categoria: 'Servicios Basicos',
    patrones: [
      /\bluz\b/i, /\bagua\b/i, /\bgas\b(?!\s*olina)/i, /internet/i,
      /telef[oó]n(o|ico|ica)/i, /servicio\s+telef/i,
      /\bcfe\b/i, /telmex/i, /\bizzi\b/i, /totalplay/i, /megacable/i,
      /recolecci[oó]n\s+de\s+basura/i, /servicios?\s+b[aá]sicos?/i,
      /recarga\s+telef[oó]nica/i, /plan\s+telef[oó]nico/i, /l[ií]nea\s+telef[oó]nica/i,
      /pago\s+de\s+agua/i, /pago\s+de\s+luz/i, /pago\s+de\s+internet/i,
    ],
  },
  {
    categoria: 'Mantenimiento',
    patrones: [
      /mantenimiento/i, /reparaci[oó]n/i, /plomer[ií]a/i, /electric/i, /pintura/i,
      /aire\s*acondicionado/i, /cable\s+red/i, /fuente\s+poder/i, /hoja\s+mdf/i,
      /refacci[oó]n/i, /herramienta/i, /instalaci[oó]n\s+(de\s+)?clima/i,
      /\bclima(s)?\b/i, /proyector/i, /amplificador/i, /\bbocina/i,
      /cinta\s+aislar/i, /contacto\s+doble/i, /repuesto\s+de\s+rodillo/i,
      /rodillo/i, /tornillo/i, /broca/i, /taladro/i, /pintura/i,
      /impermeabilizan/i, /soldadura/i, /cerradura/i, /chapa\b/i,
      /vidrio\s+roto/i, /cambio\s+de\s+foco/i, /\bfocos?\b/i, /l[aá]mpara/i,
      /base\s+proyector/i, /instalaci[oó]n/i,
    ],
  },
  {
    categoria: 'Insumos',
    patrones: [
      // Papelería / oficina / equipo menor
      /papeler[ií]a/i, /\bpapel\b/i, /sobres?\b/i, /insumo/i,
      /folder/i, /clip(s)?\b/i, /pluma(s)?\b/i, /marcador(es)?\b/i,
      /caja\s+con\s+\d+\s+sobres/i,
      /bol[ií]grafo(s)?/i, /grapas?/i, /engrapadora/i, /marca[\s-]?texto(s)?/i,
      /resaltador(es)?/i, /corrector(es)?/i, /tijera(s)?/i, /cinta\s+(adhesiva|canela|diurex|masking)/i,
      /\bdiurex\b/i, /post[\s-]?it/i, /postit/i, /notas?\s+adhesivas?/i,
      /l[aá]piz|lapiz|l[aá]pices|lapices/i, /sacapuntas/i, /goma\s+de\s+borrar/i,
      /cuaderno(s)?/i, /libreta(s)?/i, /carpeta(s)?/i,
      /perforadora/i, /tachuela(s)?/i, /chinche(s|ta(s)?)?/i, /binder/i,
      /foil(s)?\b/i, /acetato(s)?/i, /charola(s)?/i, /archivador(es)?/i,
      /cartucho(s)?\s+(de\s+)?tinta/i, /tinta\s+(impresora|epson|hp|brother)/i,
      /impresi[oó]n\s+de\s+hojas?/i, /hojas?\s+(blancas?|bond|carta|oficio|de\s+m[aá]quina)/i,
      /hojas?\s+de\s+m[aá]quina/i, /paquete\s+de\s+hojas/i, /block\s+de\s+notas?/i,
      /pegamento/i, /silicon/i, /regla(s)?\b/i,
      /plum[oó]n(es)?/i, /cray[oó]n(es)?/i, /gis(es)?\b/i, /pizarra/i,
      /borrador(es)?/i, /masking\s*tape/i, /cinta\s+masking/i,
      /\bmouse\b/i, /teclado/i, /usb\b/i, /memoria\s+usb/i, /\bcelular\b/i,
      /\bbancos?\b/i, /silla(s)?\b/i, /escritorio/i,
      /t[oó]ner/i, /trovicel/i, /foam\s*board/i, /foamboard/i, /opalina(s)?/i,
      /cartulina(s)?/i, /foami/i, /fomi\b/i, /acr[ií]lico(s)?/i, /plastificado/i,
      // Limpieza / aseo / consumibles de sucursal
      /limpiador/i, /limpiavidrios?/i, /limpia\s*vidrios?/i, /limpiacristales?/i, /limpia\s*cristales?/i,
      /\bcloro\b/i, /fabuloso/i, /\bwindex\b/i, /pinol/i, /\blysol\b/i,
      /aroma\s*l[ií]quido/i, /\baroma\b/i, /aromatizante/i, /desinfectante/i,
      /desodorante\s+ambiental/i, /gel\s+antibacterial/i, /antibacterial/i,
      /toalla\s*rollo/i, /rollo\s*secante/i, /toallas?\s*(de\s*)?(papel|rollo|manos)?/i,
      /papel\s*higi[eé]nico/i, /servilletas?/i, /shampoo\s+para\s+manos/i,
      /jab[oó]n(\s+(l[ií]quido|para\s+manos|de\s+manos))?/i,
      /bolsa(s)?(\s+(de\s+)?(asa|basura|camiseta|t\/?\s*camiseta))?/i,
      /bolsa\s+t\s*\/?\s*camiseta/i,
      /bot(e|es)?\s*(de\s*|para\s+(la\s+)?)?basura/i,
      /bote(s)?\s*(sin\s+tapa|con\s+tapa|de\s+\d+\s*l)/i,
      /cesto(s)?\s*(de\s*)?basura/i,
      /trapo(s)?\b/i, /jerga(s)?\b/i, /tela\s+absorbente/i,
      /trapeador(es)?/i, /escoba(s)?/i, /recogedor(es)?/i, /atomizador(es)?/i,
      /[aá]cido\s+muri[aá]tico/i, /insecticida/i,
      /pastilla\s+wie/i, /pastilla(s)?\s*(aromatizante|sanitaria|wc|ba[nñ]o|para\s+ba[nñ]o)/i,
      /fibra\s+(verde|esponja)/i, /esponja(s)?/i,
      /guantes?/i, /cubeta(s)?/i,
      /cepillo(\s+para)?(\s+(lavar|de))?\s*(el\s+)?(ba[nñ]o|limpieza|piso)?/i,
      /\blimpieza\b/i,
    ],
  },
  {
    categoria: 'Servicios especiales',
    patrones: [
      /contador/i, /notario/i, /abogado/i, /asesor[ií]a/i, /capacitaci[oó]n/i,
      /curso\s+/i, /extorsi[oó]n/i, /seguro/i, /vigilancia/i, /fumigaci[oó]n/i,
      /mensualidad\s+a\s+contador/i, /reforma\s+laboral/i,
      /\benv[ií]o(s)?\b/i, /servicio\s+de\s+env[ií]o/i,
      /maniobras?\s+de\s+carga/i, /carga\s+y\s+descarga/i,
    ],
  },
  {
    categoria: 'Otros gastos',
    patrones: [/devoluci[oó]n/i, /reembolso/i, /varios/i, /otro\s+gasto/i],
  },
]

function normalizar (texto) {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

/**
 * @param {string} concepto
 * @param {string} [elemento]
 * @returns {string}
 */
export function clasificarCategoriaIaEgreso (concepto, elemento) {
  const texto = [concepto, elemento].filter(Boolean).join(' ')
  if (!texto.trim()) return 'Otros gastos'

  const textoNorm = normalizar(texto)

  // Teachers: sabatina / sábado sem / quincena entre paréntesis
  if (
    /\bsabatina\b/i.test(textoNorm) ||
    /\(\s*quincena\s+\d+\s*\)/i.test(texto) ||
    /\(\s*s[aá]bado\s+sem/i.test(texto) ||
    /\(\s*sabado\s+sem/i.test(textoNorm)
  ) {
    return 'Nómina Teachers'
  }

  // Operaciones: intendencia, limpia externa pagada a persona, (semana N), (Q1/Q2)
  if (
    /\bintendencia\b/i.test(textoNorm) ||
    /visita(s)?\s+por\s+servicio\s+de\s+limpieza/i.test(textoNorm) ||
    /servicio\s+de\s+limpieza\s+a\s+/i.test(textoNorm) ||
    /\bsemana\s+\d+\b/i.test(textoNorm) ||
    /\(\s*Q[12]\s*\)/i.test(texto)
  ) {
    return 'Nómina Operaciones'
  }

  for (let i = 0; i < REGLAS.length; i++) {
    const regla = REGLAS[i]
    for (let j = 0; j < regla.patrones.length; j++) {
      if (regla.patrones[j].test(texto)) {
        return regla.categoria
      }
    }
  }

  const el = normalizar(elemento)
  if (el) {
    if (el.indexOf('teacher') !== -1) return 'Nómina Teachers'
    if (el.indexOf('nomina administrativa') !== -1 || el.indexOf('nmina administrativa') !== -1) return 'Nómina Operaciones'
    if (el.indexOf('renta') !== -1) return 'Renta sucursal'
    if (el.indexOf('marketing') !== -1) return 'Marketing'
    if (el.indexOf('mantenimiento') !== -1) return 'Mantenimiento'
  }

  return 'Otros gastos'
}

export function colorCategoriaIaEgreso (categoria) {
  return COLOR_POR_CATEGORIA[categoria] || '#757575'
}

/**
 * Asigna categoria_ia a cada partida (mutación in-place o copia).
 * @param {Array<object>} partidas
 * @returns {Array<object>}
 */
export function enriquecerPartidasConCategoriaIa (partidas) {
  const lista = Array.isArray(partidas) ? partidas : []
  for (let i = 0; i < lista.length; i++) {
    const item = lista[i]
    if (!item) continue
    item.categoria_ia = clasificarCategoriaIaEgreso(
      item.concepto,
      item.elemento_mantenimiento || item.elemento
    )
  }
  return lista
}
